/** @jsxImportSource @emotion/react */
import type { IValueProps } from 'modules/main/ui/components/section/components/value';
import Value from 'modules/main/ui/components/section/components/value/value';
import React from 'react';
import { theme } from 'styles/theme/theme';
import type { DivProps } from 'typings';
import { Divider } from 'ud-ui/components';
import * as S from './styles';

interface IProps extends DivProps {
  values: IValueProps[];
}

function ValueGroup(props: IProps) {
  const { values, ...rest } = props;

  return (
    <S.MainBlock {...rest}>
      {values.map((value, i) => {
        return (
          <>
            {i !== 0 && <Divider type="vertical" color={theme.colors.WhiteGray20} key={'divider' + i} />}
            <Value {...value} key={'value' + i} />
          </>
        );
      })}
    </S.MainBlock>
  );
}

export default ValueGroup;
